export var E_PERMISSION_KEY;
(function (E_PERMISSION_KEY) {
    E_PERMISSION_KEY["CASE_GLOBAL_VIEW_DISPLAY_MRZ_CHECK_MODULE"] = "caseGlobalView.displayMrzCheckModule";
    E_PERMISSION_KEY["CASE_GLOBAL_VIEW_DISPLAY_UPLOAD_MODULE"] = "caseGlobalView.displayUploadModule";
    E_PERMISSION_KEY["CASE_GLOBAL_VIEW_DISPLAY_COMMENT_MODULE"] = "caseGlobalView.displayInternalCommentsModule";
    E_PERMISSION_KEY["USER_MANAGEMENT_IMPORT"] = "userManagement.import";
    E_PERMISSION_KEY["USER_MANAGEMENT_VIEW"] = "userManagement.view";
    E_PERMISSION_KEY["CASE_SEARCH_FILTERS_VIEW"] = "caseSearch.filters.view";
    E_PERMISSION_KEY["CASE_SEARCH_RESULTS_VIEW"] = "caseSearch.results.view";
    E_PERMISSION_KEY["CASE_SEARCH_USER_CUSTOM_SEARCH_PERFORM"] = "caseSearch.userCustomSearch.perform";
    E_PERMISSION_KEY["CASE_SEARCH_AUTO_PLAY_PERFORM"] = "caseSearch.autoPlay.perform";
})(E_PERMISSION_KEY || (E_PERMISSION_KEY = {}));
